module.exports = __webpack_public_path__ + "media/images/front/varieties/CHISLETT-740d007c16b550d9140265eaa6f127b5.jpg";